import Button from '@/components/Button';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

interface ProductListErrorStateProps {
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

const ProductListErrorState = ({
  message = 'Something went wrong while loading this data.',
  onRetry,
  retryLabel = 'Try again',
}: ProductListErrorStateProps) => (
  <div role="alert" className="flex flex-col items-center justify-center gap-4 py-20 text-center">
    <p className="max-w-md text-sm text-gray-600">{message}</p>
    {onRetry && (
      <Button
        onClick={onRetry}
        variant="secondary"
        icon={<ArrowPathIcon className="h-5 w-5 mr-1" aria-hidden="true" />}
      >
        {retryLabel}
      </Button>
    )}
  </div>
);

export default ProductListErrorState;
